// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".value-collapse[data-v-69700f82] {\n  border: 1px solid #777c7f;\n}\n.value-collapse .collapse-header.not-collapsed[data-v-69700f82] {\n    background-color: #777c7f;\n}\n.new-value-box[data-v-69700f82] {\n  background-color: #53575B;\n}\n.new-value-box p[data-v-69700f82] {\n    color: #fff;\n    font-size: 12px;\n}\n.top-4[data-v-69700f82] {\n  top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
